import { RowScaffold } from "../../interface";

/**
 * Builds a list of row entries for a range between two rows.
 * Includes all rows whose rowNumber falls between the anchor and target (inclusive).
 *
 * @param rows - All available scaffold rows.
 * @param anchorRowId - The row ID of the selection anchor.
 * @param targetRowId - The row ID of the target row.
 * @returns An array of row selection entries covering the range.
 */
export const buildRowRange = <T>(
  rows: RowScaffold<T>[],
  anchorRowId: string,
  targetRowId: string,
): { firstCellId: string }[] => {
  const anchorRow = rows.find((r) => r.id === anchorRowId);
  const targetRow = rows.find((r) => r.id === targetRowId);

  if (!anchorRow || !targetRow) {
    return [];
  }

  const minRowNum = Math.min(anchorRow.rowNumber, targetRow.rowNumber);
  const maxRowNum = Math.max(anchorRow.rowNumber, targetRow.rowNumber);

  return rows
    .filter((r) => r.rowNumber >= minRowNum && r.rowNumber <= maxRowNum)
    .map((r) => ({ firstCellId: r.id }));
};
